import data from './data/excavation'
let excavation = {
  "pinned": [
    "DealID",
    "CommonName",
    "Memo"
  ],
  "width": {
    "DealID": 90,
    "CommonName": 240,
    "Memo": 1
  },
  "immutable": {
    "DealID": true,
    "Memo": true
  },
  "sources": [
    {
      "source": "AFS",
      "citation": "Q4 2018 Audited Financial Statements"
    },
    {
      "source": "LPA",
      "citation": "Second Amended and Restated Agreement of Exempted Limited Partnership dated January 1, 2019"
    },
    {
      "source": "Side Letter",
      "citation": "Side Letter dated August 9, 2018"
    },
    {
      "source": "Sub Doc",
      "citation": "AACP V Subscription Document"
    },
    {
      "source": "FX Rate",
      "citation": "Oanda FX Rate"
    },
    {
      "source": "Commitments",
      "citation": "NIC Commitments Table"
    },
    {
      "source": "Closing Email",
      "citation": "Closing email dated 1/8/19"
    }
  ],
  "mapping": {
    "DealID": {
      "header": "Deal ID",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "DealID",
    },
    "FolderPath": {
      "header": "Folder Path for backup",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "FolderPath",
    },
    "CommonName": {
      "header": "Common/Project Name",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "CommonName",
      "citation": "LPA"
    },
    "LegalEntity": {
      "header": "Investment Legal Entity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LegalEntity",
      "citation": "LPA"
    },
    "GPEntity": {
      "header": "General Partner Entity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "GPEntity",
      "citation": "LPA"
    },
    "Manager": {
      "header": "Manager Name",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "Manager",
      "citation": "LPA"
    },
    "LEDomicile": {
      "header": "Domicile of Investment Legal Entity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LEDomicile",
      "citation": "LPA"
    },
    "LEStructure": {
      "header": "Structure of Investment Legal Entity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LEStructure",
      "citation": "LPA"
    },
    "Description": {
      "header": "Investment Description",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "Description",
      "citation": "Description from Asia Alt Financial Statement"
    },
    "InvType": {
      "header": "Investment Type",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "InvType",
      "citation": "From BL Commitment Summary"
    },
    "DealCurrency": {
      "header": "Deal Local Currency",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "DealCurrency",
      "citation": "LPA 3.1"
    },
    "FXRate": {
      "header": "FX Rate on the Commitment Date for Non-USD Deals",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "FXRate",
      "citation": "FX Rate"
    },
    "LEFundSize": {
      "header": "Total Fund Size of Legal Entity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LEFundSize",
      "citation": "AFS Note 4"
    },
    "GPCommitLE": {
      "header": "GP Fund Commtiment to legal Entity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "GPCommitLE",
      "citation": "AFS Note 4"
    },
    "LPCommitLE": {
      "header": "LP Fund Commitment to Legal Entity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LPCommitLE",
      "citation": "AFS Note 4"
    },
    "GroupFundSize": {
      "header": "Total Fund Size of Grouping Fund",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "GroupFundSize",
      "citation": "AFS Note 4"
    },
    "GPCommitGF": {
      "header": "GP Fund Commtiment to Grouping Fund",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "GPCommitGF",
      "citation": "AFS Note 4"
    },
    "LPCommitGF": {
      "header": "LP Fund Commitment to Grouping Fund",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LPCommitGF",
      "citation": "AFS Note 4"
    },
    "FinalCloseDate": {
      "header": "Final Closing Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "FinalCloseDate",
      "citation": "BL Commitment Summary"
    },
    "VintageYear": {
      "header": "Vintage Year",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "VintageYear",
      "citation": "Closing Email"
    },
    "CommitDate": {
      "header": "Commitment Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "CommitDate"
    },
    "InitialCloseDate": {
      "header": "Initial Closing Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "InitialCloseDate",
      "citation": "\"LPA \"\"Partnership Initial Closing Date\"\"\""
    },
    "InvEndDate": {
      "header": "Investment Period End Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "InvEndDate",
      "citation": "\"Definition of \"\"Investment Period\"\"\""
    },
    "InvDescription": {
      "header": "Investment Period Description and Extention Terms",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "InvDescription",
      "citation": "\"LPA 11 \"\"Commitment Period\"\", LPA 11 \"\"First Closing Date of the Japan Fund\"\"\""
    },
    "FeeStepDownDate": {
      "header": "Asia Alt Management Fee Step Down Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "FeeStepDownDate",
      "citation": "Math - first half year after the fifth anniversary of the end of the Investment Period"
    },
    "LETermDate": {
      "header": "Fund Termination Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LETermDate",
      "citation": "LPA 9.1"
    },
    "LETermDescription": {
      "header": "Fund Termination Description and Extension Terms",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LETermDescription"
    },
    "ARFundTermText": {
      "header": "Annual Report Fund Termination Text",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "ARFundTermText",
      "citation": "LPA 9.1"
    },
    "LiquidDate": {
      "header": "Liquidation Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LiquidDate"
    },
    "LiquidNotes": {
      "header": "Liquidation Notes",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "LiquidNotes"
    },
    "DealLimit": {
      "header": "Single Deal Limit",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "DealLimit",
      "citation": "LPA 6.4(a)"
    },
    "DealLimitComps": {
      "header": "Single Deal Limit - included components",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "DealLimitComps",
      "citation": "LPA 6.4(a)"
    },
    "DebtLimit": {
      "header": "Debt Limit Percentage",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "DebtLimit",
      "citation": "LPA 5.1.2 (f)"
    },
    "DebtLimitTerms": {
      "header": "Debt Limit - Included Terms",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "DebtLimitTerms",
      "citation": "LPA 5.1.2 (f)"
    },
    "OtherLimits": {
      "header": "Other Limits",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "OtherLimits",
      "citation": "LPA 6.2(b)"
    },
    "MFeeInitialRate": {
      "header": "Management Fee Initial Rate",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "MFeeInitialRate",
      "citation": "\"Definition of \"\"Applicable Management Fee Rate\"\"\""
    },
    "MFeeInitialBase": {
      "header": "Management Fee Initial Base",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "MFeeInitialBase",
      "citation": "LPA 5.2(a)"
    },
    "MFeeStepDownRate": {
      "header": "Management Fee Step Down Rate",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "MFeeStepDownRate",
      "citation": "LPA 5.2(b)"
    },
    "MFeeStepDownBase": {
      "header": "Management Fee Step Down Base",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "MFeeStepDownBase",
      "citation": "LPA 5.2(b)"
    },
    "MFeeStepDownTime": {
      "header": "Management Fee Time of Step Down",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "MFeeStepDownTime",
      "citation": "LPA 5.2(b)"
    },
    "MFeeDiscount": {
      "header": "Management Fee Discount",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "MFeeDiscount",
      "citation": "Side Letter #7"
    },
    "MFeeTerms": {
      "header": "Summary of Management Fee Terms",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "MFeeTerms"
    },
    "WaterFallTerms": {
      "header": "Summary of Waterfall Terms  ",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "WaterFallTerms"
    },
    "HurdleRate": {
      "header": "Hurdle / Preferred Return Rate",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "HurdleRate",
      "citation": "\"Definition of \"\"Preferred Return\"\"\""
    },
    "CarryRate": {
      "header": "Carry Rate",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "CarryRate",
      "citation": "LPA 4.3"
    },
    "AsiaAltDiscount": {
      "header": "Asia Alt Discount",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "AsiaAltDiscount",
      "citation": "Side Letter #6"
    },
    "WaterFallType": {
      "header": "Carry Waterfall Type",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "WaterFallType",
      "citation": "LPA 4.3"
    },
    "ClawBackTiming": {
      "header": "Carry Claw-back Timing",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "ClawBackTiming",
      "citation": "\"LPA 9.3(f)"
    },
    "ClawBackDate": {
      "header": "Claw-Back Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "ClawBackDate",
      "citation": "LPA 9.3(f)"
    },
    "ClawBackIndemnity": {
      "header": "Summary of Claw-Back/Indemnity",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "ClawBackIndemnity"
    },
    "FinRepQuarter": {
      "header": "Financial Reporting:  Quarterly Deadline",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "FinRepQuarter",
      "citation": "LPA 11.3(a)"
    },
    "FinRepAnnual": {
      "header": "Financial Reporting:  Annual Audit Deadline",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "FinRepAnnual",
      "citation": "LPA 11.3(b)"
    },
    "FinRepTax": {
      "header": "Financial Reporting:  Tax Deadline",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "FinRepTax",
      "citation": "LPA 11.3(c) "
    },
    "FiscalEnd": {
      "header": "Fiscal Calendar End Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "FiscalEnd",
      "citation": "LPA 11.2"
    },
    "SOIGrouping": {
      "header": "Investment Grouping for SOI",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "SOIGrouping",
      "citation": "Asia Alt Financial Statements"
    },
    "AsiaAltGPLegalEntity": {
      "header": "Asia Alt GP Legal Entity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "AsiaAltGPLegalEntity",
      "citation": "Asia Alt Financial Statements"
    },
    "AsiaAltGPLegalEntityCommitment": {
      "header": "Asia Alt GP Legal Entity Commitment",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "AsiaAltGPLegalEntityCommitment",
      "citation": "Asia Alt Financial Statements"
    },
    "KeyPersons": {
      "header": "Key Persons",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "element": "text",
      "palceholder": null,
      "validations": [],
      "col": "KeyPersons"
    },
    "FundFamily": {
      "header": "Fund Family",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "element": "textarea",
      "palceholder": null,
      "validations": [],
      "col": "FundFamily"
    },
/*    "AsiaAltCommitmentAllAffiliates": {
      "header": "AsiaAltCommitmentAllAffiliates",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "element": "textarea",
      "palceholder": null,
      "validations": [],
      "col": "AsiaAltCommitmentAllAffiliates"
    },
    "AsiaAltGPLegalEntityCommitment": {
      "header": "AsiaAltGPLegalEntityCommitment",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "element": "textarea",
      "palceholder": null,
      "validations": [],
      "col": "AsiaAltGPLegalEntityCommitment"
    },
    "AsiaAltGPLegalEntity": {
      "header": "AsiaAltGPLegalEntity",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "element": "textarea",
      "palceholder": null,
      "validations": [],
      "col": "AsiaAltGPLegalEntity"
    },
    "PEConsortium": {
      "header": "PEConsortium",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "element": "textarea",
      "palceholder": null,
      "validations": [],
      "col": "PEConsortium"
    },  */
    "Memo": {
      "header": "Notes",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "element": "textarea",
      "palceholder": null,
      "validations": [],
      "col": "Memo"
    },
    "CommitmentFirstCommitmentDate": {
      "header": "Commitment First Commitment Date",
      "rules": null,
      "dataType": "date",
      "meta": null,
      "palceholder": null,
      "validations": [],
      "col": "CommitmentFirstCommitmentDate"
    },
  }
}
export  { excavation }
